"use client";
import MainContent from "@/components/MainContent";
import React, { ReactNode } from "react";
import { HeaderWithLayout, SearchBarWithResults } from "@webelocity/ui";
import TopHeader from "../TopHeader/TopHeader";
import ServicesNav from "../ServicesNav/ServicesNav";
import Footer from "../Footer/Footer";
import MobileNavLinks from "../MobileNavLinks/MobileNavLinks";

interface MainLayoutProps {
  children: ReactNode;
  monthlyFlyerUrl: string;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children, monthlyFlyerUrl }) => (
  <>
    <TopHeader />
    <HeaderWithLayout searchSlot={<SearchBarWithResults />} />
    <MobileNavLinks monthlyFlyerUrl={monthlyFlyerUrl} />
    <ServicesNav monthlyFlyerUrl={monthlyFlyerUrl} />
    <MainContent>{children}</MainContent>
    <Footer />
  </>
);

export default MainLayout;
